import { useCallback, useEffect, useState } from "react";
import api from "../../../../utils/axiosInstance";
import { toast } from "../../../../components/Toast/toast";
import ObjectCodesView from "./ObjectCodesView";
import ObjectCodesForm from "./ObjectCodesForm";

const ObjectCodesPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/object-codes");
      setData(res.data.data);
    } catch (err) {
      console.error("Failed to load object codes", err);
      setError(err.response?.data?.message || "Failed to load custom codes.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleSave = async (payload) => {
    try {
      const res = await api.put("/object-codes", payload);
      setData((prev) => ({ ...prev, ...res.data.data }));
      toast.success(res.data.message || "Custom codes updated.");
      return true;
    } catch (err) {
      toast.error(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Could not save the custom codes."
      );
      return false;
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <div className="h-8 w-8 animate-spin rounded-full border border-gray-300 border-t-brand-600" />
      </div>
    );
  }

  if (error) return <p className="text-sm text-danger-600">{error}</p>;

  // Editing replaces the overview with its own screen, matching the Account
  // and client detail pages.
  if (editing) {
    return (
      <ObjectCodesForm
        includeYear={data.include_year_in_codes}
        codes={data.codes}
        onSave={handleSave}
        onCancel={() => setEditing(false)}
      />
    );
  }

  return (
    <ObjectCodesView
      includeYear={data.include_year_in_codes}
      codes={data.codes}
      canEdit={data.can_edit}
      onEdit={() => setEditing(true)}
    />
  );
};

export default ObjectCodesPage;
